import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Button, Modal, Form, OverlayTrigger, Tooltip} from 'react-bootstrap';

import { getUsers, addUser, deleteUser } from './UsersActions';
import Confirm from '../../components/Modal/Confirm';
import Loading from '../../components/Loading/Loading';

import profileImage from '../../assets/images/default-image.svg';
import deleteIcon from '../../assets/images/delete-icon.svg';
import Close from '../../assets/images/close.svg';
import MailIcon from '../../assets/images/mail-icon.svg';

import warningIcon from '../../assets/images/warning.svg';

import './Users.scss';

const PAGE_SIZE = 8;

function getUserStatus(user) {
  if (user.disabled) return 'Disabled';
  if (user.activated) return 'Activated';
  return 'Pending Activation';
}

class Users extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
      name: '',
      email: '',
      search: '',
      page: 1,
      sortDir: 'asc',
    };
  }

  componentDidMount() {
    this.props.getUsers();
  }

  onOpen = () => {
    this.setState({ isOpened: true, page: 1, search: '' }, () => {
      this.props.getUsers();
    });
  };

  onClose = (event) => {
    if (event) event.stopPropagation();
    this.setState({ isOpened: false });
  };

  handleChange = (ev) => {
    this.setState({ [ev.target.name]: ev.target.value, page: 1 });
  };

  handleSubmit = (ev) => {
    this.props
      .addUser({
        name: this.state.name,
        email: this.state.email,
      })
      .then(() => {
        this.setState({
          name: '',
          email: '',
        });
      })
      .catch(() => {});
  };

  handleInvite = () => {
    this.props
      .addUser({ name: this.state.name, email: this.state.email })
      .then(() => {
        this.setState({ name: '', email: '' });
      })
      .catch(() => {});
  };

  toggleSort = () => {
    this.setState((prev) => ({ sortDir: prev.sortDir === 'asc' ? 'desc' : 'asc', page: 1 }));
  };

  setPage = (page) => {
    this.setState({ page });
  };

  getFilteredUsers() {
    const { users } = this.props;
    const { search, sortDir } = this.state;
    let filtered = users;

    if (search) {
      const q = search.toLowerCase();
      filtered = users.filter(
        (u) =>
          (u.email && u.email.toLowerCase().includes(q)) ||
          (u.name && u.name.toLowerCase().includes(q))
      );
    }

    filtered = [...filtered].sort((a, b) => {
      const emailA = (a.email || '').toLowerCase();
      const emailB = (b.email || '').toLowerCase();
      if (emailA < emailB) return sortDir === 'asc' ? -1 : 1;
      if (emailA > emailB) return sortDir === 'asc' ? 1 : -1;
      return 0;
    });

    return filtered;
  }

  renderPagination(total, page, pageSize) {
    const totalPages = Math.ceil(total / pageSize);
    if (totalPages <= 1) return null;

    const pages = [];
    for (let i = 1; i <= Math.min(totalPages, 6); i++) {
      pages.push(i);
    }
    if (totalPages > 6) {
      pages.push(totalPages);
    }

    return (
      <div className='users_modal__pagination'>
        <span className='users_modal__pagination-total'>Total {total} items</span>
        <div className='users_modal__pagination-pages'>
          <button
            className='users_modal__pagination-arrow'
            disabled={page === 1}
            onClick={() => this.setPage(page - 1)}
          >
            ‹
          </button>
          {pages.map((p, i) => {
            const prev = pages[i - 1];
            return (
              <React.Fragment key={p}>
                {prev && p - prev > 1 && <span className='users_modal__pagination-ellipsis'>…</span>}
                <button
                  className={`users_modal__pagination-page${page === p ? ' active' : ''}`}
                  onClick={() => this.setPage(p)}
                >
                  {p}
                </button>
              </React.Fragment>
            );
          })}
          <button
            className='users_modal__pagination-arrow'
            disabled={page === totalPages}
            onClick={() => this.setPage(page + 1)}
          >
            ›
          </button>
        </div>
      </div>
    );
  }

  render() {
    const { isLoading, isAdding, users } = this.props;
    const { isOpened, name, email, search, page, sortDir } = this.state;

    const tooltip = <Tooltip>Not activated</Tooltip>;

    const filtered = this.getFilteredUsers();
    const total = filtered.length;
    const pageUsers = filtered.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE);

    const modal = (
      <Modal show={isOpened} onHide={this.onClose} className='users_modal' size='xl'>
        <Modal.Header>
          <Modal.Title>Users</Modal.Title>
          <Button variant="close" onClick={this.onClose}>
            <img src={Close} alt="close" />
          </Button>
        </Modal.Header>

        <Modal.Body>
          <div className='users_modal__invite'>
            <Form.Group className='form-field'>
              <Form.Label>Name</Form.Label>
              <Form.Control
                name="name"
                type="text"
                id="name"
                value={name}
                onChange={this.handleChange}
              />
            </Form.Group>
            <Form.Group className='form-field'>
              <Form.Label>Email</Form.Label>
              <Form.Control
                name="email"
                type="email"
                value={email}
                onChange={this.handleChange}
              />
            </Form.Group>
            <Button
              variant="primary"
              size="md"
              onClick={this.handleInvite}
              disabled={isAdding}
            >
              <img src={MailIcon} alt="#" /> 
              {isAdding ? 'Sending...' : 'Invite User'}
            </Button>
          </div>

          <div className='table_wrapper'>
            <div className='table_filter'>
              <Form.Group controlId="Search" className="search-form">
                <Form.Control
                  type="text"
                  name="search"
                  placeholder="Search"
                  onChange={this.handleChange}
                  value={search}
                />
              </Form.Group>
            </div>
            <div className='table'>
              <table>
                <thead>
                  <tr>
                    <th onClick={this.toggleSort} className='sortable'>
                      Email <span className='sort-icon'>{sortDir === 'asc' ? '↓' : '↑'}</span>
                    </th>
                    <th>Name</th>
                    <th>Status</th>
                    <th className='action'>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {pageUsers &&
                    pageUsers.map((user, i) => {
                      const status = getUserStatus(user);
                      return (
                        <tr key={i}>
                          <td>
                            <span className='email'>{user.email}</span>
                            {!user.activated && (
                              <OverlayTrigger placement="top" overlay={tooltip}>
                                <span className='warning'>
                                  <img src={warningIcon} alt="pending" />
                                </span>
                              </OverlayTrigger>
                            )}
                          </td>

                          <td>
                            <div className='user-avatar'>
                              <div className='avatar'><img src={user.photo || profileImage} alt="#" /></div>
                              {user.name}
                            </div>
                          </td>
                          
                          <td>
                            <span className={`users_modal__status users_modal__status--${status.toLowerCase().replace(/\s+/g, '-')}`}>
                              {status}
                            </span>
                          </td>
                          
                          <td className='action'>
                            <Confirm
                              body={
                                <p>
                                  Are you sure you want to remove <br />
                                  <strong>{user.name}</strong> from this account?
                                </p>
                              }
                              confirmText="Remove"
                              icon={deleteIcon}
                              title="Remove user"
                              onConfirm={() => this.props.deleteUser(user._id)}
                            >
                              <Button className='btn-icon' variant='delete' size='md'>
                                <img src={deleteIcon} alt="delete" />
                              </Button>
                            </Confirm>
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
              {this.renderPagination(total, page, PAGE_SIZE)}
              {isLoading && (
                <div className='table-loading'>
                  <Loading />
                </div>
              )}
              {!isLoading && users.length === 0 && (
                <div className='no_data'>
                  <p> No data available </p>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={this.onClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    );

    if (this.props.children) {
      const btn = React.Children.only(this.props.children);
      return React.cloneElement(btn, { onClick: this.onOpen }, btn.props.children, modal);
    }

    return (
      <Button onClick={this.onOpen}>
        Users
        {modal}
      </Button>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUsers: () => dispatch(getUsers()),
    addUser: (model) => dispatch(addUser(model)),
    deleteUser: (id) => dispatch(deleteUser(id)),
  };
};

function mapStateToProps(state) {
  return {
    users: state.users.list,
    isLoading: state.users.isLoading,
    isAdding: state.users.isAdding,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Users);
